import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { switchMap } from 'rxjs/operators';

export interface Communication {
  id: number;
  title: string;
  body: string;
  createdAt: string;
  condominiumId: number;
  authorName: string;
}

export interface CommunicationResponse {
  _embedded: {
    communicationResponseDTOList: Communication[];
  };
  _links: any;
  page: {
    size: number;
    totalElements: number;
    totalPages: number;
    number: number;
  };
}

@Injectable({
  providedIn: 'root'
})
export class CommunicationsService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) { }

  getCommunications(condominiumId: number, page: number = 0, size: number = 10): Observable<CommunicationResponse> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        return this.http.get<CommunicationResponse>(`${environment.apiUrl}/communications`, {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            condominiumId: condominiumId.toString(),
            page: page.toString(),
            size: size.toString()
          }
        });
      })
    );
  }

  getCommunicationById(id: number): Observable<Communication> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        return this.http.get<Communication>(`${environment.apiUrl}/communications/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      })
    );
  }

  createCommunication(communication: Omit<Communication, 'id' | 'createdAt'>): Observable<Communication> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        return this.http.post<Communication>(`${environment.apiUrl}/communications`, communication, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      })
    );
  }

  deleteCommunication(id: number): Observable<void> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        return this.http.delete<void>(`${environment.apiUrl}/communications/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      })
    );
  }
}
